/**
 * @generated SignedSource<<2b7630f2667e80dcd4710e084e0e91b3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BookedOutFragment$data = {
  readonly id: string;
  readonly bookedOut: boolean;
  readonly " $fragmentType": "BookedOutFragment";
};
export type BookedOutFragment$key = {
  readonly " $data"?: BookedOutFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"BookedOutFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "node"
      ],
      "operation": require('./bookedOutFragmentRefetchQuery.graphql'),
      "identifierField": "id"
    }
  },
  "name": "BookedOutFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "bookedOut",
      "storageKey": null
    }
  ],
  "type": "Caregiver",
  "abstractKey": null
};

(node as any).hash = "10442062fb9eba1ec8fa7eca5a3817c0";

export default node;
